export const COURSES_PRESELECTED_FILTERS = 'preselected_filters';
